export interface DeletedStation {
  interfaceId: number
  stationId: number
}

export const isDeletedStation = (
  station: { id: number; interfaceId: number },
  deleted: DeletedStation,
): boolean => station.id === deleted.stationId && station.interfaceId === deleted.interfaceId

const STATION_DELETED_EVENT = 'cisgenics:station-deleted'

export const publishStationDeletion = (station: DeletedStation): void => {
  window.dispatchEvent(new CustomEvent(STATION_DELETED_EVENT, { detail: station }))
}

export const subscribeToStationDeletion = (
  onDeleted: (station: DeletedStation) => void,
): (() => void) => {
  const listener = (event: Event): void => {
    onDeleted((event as CustomEvent<DeletedStation>).detail)
  }
  window.addEventListener(STATION_DELETED_EVENT, listener)
  return () => window.removeEventListener(STATION_DELETED_EVENT, listener)
}
